/**
 * Shared metadata copy and assets for the app (layout, hotel details fallbacks, etc.).
 * Single source of truth so copy changes are updated in one place.
 */

export const GONDOLA_BASE_URL =
  process.env.NEXT_PUBLIC_BASE_URL || "https://www.gondola.ai";

export const GONDOLA_DEFAULT_DESCRIPTION =
  "Gondola is a free hotel booking tool for frequent travelers. Earn hotel points, credit card points, status nights, and 3-7% cash back on every stay.";

export const GONDOLA_DEFAULT_OG_IMAGE =
  "https://www.gondola.ai/assets/meta-bg.png";

const APP_STORE_ID = "6751292391";

/**
 * Builds the `apple-itunes-app` meta tag content with an `app-argument` URL.
 *
 * iOS reads this meta tag from the initial server-rendered HTML only — client-side
 * updates are ignored. Including `app-argument` ensures the iOS smart app banner
 * passes the current page URL to the app when the user taps "Open", instead of
 * opening the app to an empty `gondola:///` deep link.
 */
export function appleItunesAppContent(appArgumentUrl: string): string {
  return `app-id=${APP_STORE_ID}, app-argument=${appArgumentUrl}`;
}
